import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    titlePage: "Mes disponibilités",
    returnTitle: "Mon compte"
};

export type _I18nCalendar = typeof _fr;

const _en: _I18nCalendar = {
    titlePage: "My availability",
    returnTitle: "My account"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nCalendar(lang?: string): _I18nCalendar {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}